export default "__VITE_ASSET__5aa5cb28__"